<template>
  <v-app >
    <v-main class="pp-gray">
      <div v-if="!$auth.loading && $auth.validPermissions">
        <Header/>
        <router-view></router-view>
      </div>
      <div v-else-if="$auth.loading">
        <div class="center">
          <div class="loader"></div>
          <v-card-title class="text-h5 white--text">
            Loading Permission
          </v-card-title>
        </div>
      </div>
      <div v-else>
        <div class="center">
          <v-icon color="primary" x-large class="text-h1 door">mdi-door-closed-lock</v-icon>
          <v-divider dark class="mb-5"></v-divider>
          <div class="text-h5 white--text ma-auto">
            Sorry, but you are not permitted to operate this platform.
            If you believe that this is a mistake, please contact the administrator.
            <v-divider dark class="mt-5"></v-divider>
          </div>
        </div>
      </div>
      <FlashMessage :position="'right top'"></FlashMessage>
    </v-main>
  </v-app>
</template>

<script>
import Header from "./components/Header";
import {mapGetters, mapState} from "vuex";

export default {
  name: 'App',
  components: {Header},
  computed: {
    ...mapState(['latestNotification']),
    ...mapGetters(['latestNotification']),
  },
  watch: {
    latestNotification: function(newNotification, oldNotification) {

      if(JSON.stringify({...newNotification}) != JSON.stringify({...oldNotification})) {
        // @see https://smwb-tech.gitbook.io/vue-flash-message/data-object
        // status might be the most interesting 'error', 'warning', 'info', 'success'
        this.flashMessage.show(newNotification);
      }

    },
  },
};
</script>
